import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskSurveysRoute } from '@atlassian/jira-router-routes-servicedesk-surveys-routes/src/servicedeskSurveysRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { surveysPageEntryPoint } from './ui/index.tsx';

export const servicedeskSurveysRouteEntry = createEntry(servicedeskSurveysRoute, () => ({
	group: 'servicedesk',
	ufoName: 'jsm.surveys',

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
	},

	layout: serviceProjectLayout,

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],

	entryPoint: () =>
		fg('phx-2293_add_surveys_routes_under_project_settings') ? surveysPageEntryPoint : undefined,

	meta: {
		reporting: {
			id: 'surveys',
			packageName: toPackageName(APP_NAMES.SURVEYS),
			teamName: 'jsm-phoenix',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',
		bundling: {
			packageName:
				'@atlassian/jira-router-routes-servicedesk-surveys-entries/src/servicedeskSurveysRouteEntry.tsx',
			whichExportToUse: 'servicedeskSurveysRouteEntry',
		},

		enabled: true,
	},
}));
